import React from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { FaCloudUploadAlt, FaTrashAlt } from 'react-icons/fa';
import { getSize } from 'helpers/utils';

const TransactionDetailUploadAttachment = ({ files, setFiles }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*, .doc, .docx, .xls, .xlsx, .pdf',
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })),
      );
    },
  });

  const handleRemove = (path) => setFiles(files.filter((file) => file.path !== path));

  return (
    <div>
      <div
        {...getRootProps({
          className: 'tw-flex tw-items-center tw-justify-center tw-gap-2 tw-border-2 tw-border-dashed tw-border-slate-300 tw-rounded tw-py-8 tw-bg-slate-50 tw-cursor-pointer hover:tw-border-blue-400 tw-transition-colors',
        })}
      >
        <input {...getInputProps()} />
        <FaCloudUploadAlt size={24} className="tw-text-slate-400" />
        <p className="tw-mb-0 tw-text-sm tw-text-slate-600">Drop your files here</p>
      </div>

      <div className="tw-mt-3">
        {files && files.map((file) => (
          <div key={file.path} className="tw-flex tw-items-center tw-justify-between tw-py-1.5 tw-border-b tw-border-slate-100">
            <div>
              <h6 className="tw-mb-0 tw-text-sm tw-text-slate-800">{file.path}</h6>
              <p className="tw-mb-0 tw-text-xs tw-text-slate-400 tw-font-semibold">{getSize(file.size)}</p>
            </div>
            <button type="button" onClick={() => handleRemove(file.path)}
              className="tw-bg-transparent tw-border-0 tw-text-slate-400 hover:tw-text-red-500 tw-cursor-pointer tw-p-1">
              <FaTrashAlt />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

TransactionDetailUploadAttachment.propTypes = {
  files: PropTypes.array.isRequired,
  setFiles: PropTypes.func.isRequired,
};

export default TransactionDetailUploadAttachment;
